/**
 * Strips the `senders` property from each node's `data` in an initialNodes array.
 * Used when duplicating/cloning campaigns so that node-level sender overrides
 * are not carried over to the new campaign.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stripNodeSenders = (initialNodes: any[] | undefined): any[] => {
	if (!initialNodes) {
		return [];
	}

	return initialNodes.map((node) => {
		if (!node?.data?.senders) {
			return node;
		}

		const { senders: _senders, ...dataWithoutSenders } = node.data;

		return {
			...node,
			data: dataWithoutSenders,
		};
	});
};
